// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Using global content-card styles */
/* Component-specific styles if needed */
`, "",{"version":3,"sources":["webpack://./src/app/modules/common/components/submit-request/submit-request.component.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC,wCAAwC","sourcesContent":["/* Using global content-card styles */\r\n/* Component-specific styles if needed */\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
